import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@dotcom/crown-ui';
import { removeBeforeUnloadEvent } from '../../../utils';
import { CancelButtonProps } from '../system-failure-dialog-types';

export const CancelButton = ({ click }: CancelButtonProps): React.ReactElement => {
  const { t } = useTranslation();

  const onClick = () => {
    removeBeforeUnloadEvent();
    click();
  };

  return (
    <Button onClick={onClick} variant="secondary" testId="cancel-button">
      {t('systemFailureDialog.exit')}
    </Button>
  );
};
